import React, { useState } from 'react';

export const RECLAIM_REASONS = [
  { id: 'transfer', label: '전출' },
  { id: 'leave', label: '휴직·파견' },
  { id: 'retire', label: '퇴직' },
  { id: 'role_change', label: '담당 변경' },
  { id: 'other', label: '기타' },
];

const MEMO_MAX = 200;

export const reclaimToast = (name, result) => {
  if (result?.seat_returned) {
    return `${name} 선생님 자리를 회수했어요. 남은 ${result.returned_days}일은 다음에 합류하는 선생님이 이어서 써요.`;
  }
  if (result?.kept_reason === 'seat_closed') {
    return `${name} 선생님을 학교에서 내보냈어요. 이 자리는 등록 기간이 끝나 넘길 수 없어서 이용 기간은 그대로 두었어요.`;
  }
  if (result?.pro_kept) {
    return `${name} 선생님을 학교에서 내보냈어요. 선생님이 따로 결제한 PRO라 이용 기간은 그대로예요.`;
  }
  return `${name} 선생님 자리를 회수했어요. 남은 기간이 하루도 안 돼 자리는 돌아오지 않았어요.`;
};

export const ReclaimDialog = ({ name, onConfirm, onCancel, busy }) => {
  const [reason, setReason] = useState('');
  const [memo, setMemo] = useState('');
  const needsMemo = reason === 'other' && !memo.trim();

  return (
    <div className="school-dialog-backdrop" role="presentation" onClick={onCancel}>
      <div
        className="school-dialog school-reclaim"
        role="dialog"
        aria-modal="true"
        aria-label={`${name} 선생님 자리 회수`}
        onClick={(e) => e.stopPropagation()}
      >
        <h2>{name} 선생님 자리를 회수할까요?</h2>
        <ul className="school-reclaim-facts">
          <li>학교가 드린 PRO 기간 중 <strong>남은 만큼</strong>을 돌려받아요. 선생님이 따로 결제한 기간은 그대로예요.</li>
          <li>돌려받은 자리는 초대 링크로 다음에 합류하는 선생님이 남은 기간만큼 이어서 써요.</li>
          <li>선생님이 만든 기록은 선생님 계정에 그대로 남고, 안내 메일이 가요.</li>
        </ul>
        <fieldset className="school-reclaim-reasons">
          <legend>사유</legend>
          {RECLAIM_REASONS.map((item) => (
            <label key={item.id} className={`school-chip-option${reason === item.id ? ' is-active' : ''}`}>
              <input
                type="radio"
                name="reclaim-reason"
                value={item.id}
                checked={reason === item.id}
                onChange={() => setReason(item.id)}
              />
              {item.label}
            </label>
          ))}
        </fieldset>
        <label className="school-reclaim-memo">
          <span>메모 {reason === 'other' ? '(꼭 적어 주세요)' : '(선택)'}</span>
          <textarea
            value={memo}
            maxLength={MEMO_MAX}
            rows={2}
            placeholder="예: 2학기 ○○중으로 전출"
            onChange={(e) => setMemo(e.target.value)}
          />
          <small>학교 관리자만 봐요. 선생님께 가는 메일에는 넣지 않아요.</small>
        </label>
        <div className="school-dialog-actions">
          <button type="button" className="school-btn-secondary" onClick={onCancel} disabled={busy}>취소</button>
          <button
            type="button"
            className="school-btn-primary"
            onClick={() => onConfirm({ reason, memo: memo.trim() })}
            disabled={busy || !reason || needsMemo}
          >
            자리 회수
          </button>
        </div>
      </div>
    </div>
  );
};

const formatDay = (iso) => {
  const date = new Date(iso || '');
  return Number.isNaN(date.getTime()) ? '' : `${date.getMonth() + 1}월 ${date.getDate()}일`;
};

const eventText = (event) => {
  const name = `${event.display_name || '선생님'} 선생님`;
  if (event.type === 'credit_used') {
    return `${name}이 돌려받은 자리로 합류 · ${event.returned_days}일 이어서 사용`;
  }
  const reason = [event.reason_label, event.memo].filter(Boolean).join(' · ');
  if (event.seat_returned) return `${name} 자리 회수 (${reason}) · 남은 ${event.returned_days}일 돌려받음`;
  return `${name} 내보냄 (${reason}) · 이용 기간은 그대로`;
};

export const SeatHistoryCard = ({ events = [], credits = [] }) => {
  if (!events.length && !credits.length) return null;
  return (
    <section className="school-card school-seat-history" aria-label="자리 이력" data-testid="school-seat-history">
      <h2 className="school-section-title">
        자리 이력
        <small>회수 사유와 메모는 학교 관리자만 봐요</small>
      </h2>
      {credits.length > 0 && (
        <p className="school-seat-credit" data-testid="school-seat-credit">
          돌려받은 자리 {credits.length}개 · 다음에 합류하는 선생님은 남은 기간({credits.map((c) => `${c.days}일`).join(', ')})만큼 써요.
        </p>
      )}
      <ul className="school-seat-events">
        {events.map((event) => (
          <li key={event.id}>
            <span className="school-seat-event-day">{formatDay(event.at)}</span>
            <span>{eventText(event)}</span>
          </li>
        ))}
      </ul>
    </section>
  );
};
